const FONT_PRIMARY = 'DM Sans';
const typography = {
  light: {
    fontFamily: FONT_PRIMARY,
    h1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '88px',
      lineHeight: '115px',
      color: '#000000',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '62px',
      color: '#000000',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '38px',
      lineHeight: '49px',
      color: '#7A818C',
    },
    h4: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '26px',
      lineHeight: '34px',
      color: '#000000',
    },
    h5: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '31px',
      color: '#000000',
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#000000',
    },
    h7: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#000000',
    },
    b1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#55585C',
    },
    b2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#B0B6BE',
    },
    b3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#7A818C',
    },
    b4: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#B0B6BE',
    },
    cta1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '0.1em',
      color: '#B0B6BE',
    },
    cta2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#000000',
    },
    textLink1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#7A818C',
    },
  },
  twilight: {
    fontFamily: FONT_PRIMARY,
    h1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '88px',
      lineHeight: '115px',
      color: '#FFFFFF',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '62px',
      color: '#FFFFFF',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '38px',
      lineHeight: '49px',
      color: '#FFFFFF',
    },
    h4: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '26px',
      lineHeight: '34px',
      color: '#FFFFFF',
    },
    h5: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '31px',
      color: '#FFFFFF',
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    h7: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#FFFFFF',
    },
    b1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    b2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#FFFFFF',
    },
    b3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    b4: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    cta1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    cta2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    textLink1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
  },
  dark: {
    fontFamily: FONT_PRIMARY,
    h1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '88px',
      lineHeight: '115px',
      color: '#FFFFFF',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '62px',
      color: '#FFFFFF',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '38px',
      lineHeight: '49px',
      color: '#FFFFFF',
    },
    h4: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '26px',
      lineHeight: '34px',
      color: '#FFFFFF',
    },
    h5: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '31px',
      color: '#FFFFFF',
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    h7: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#FFFFFF',
    },
    b1: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    b2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#FFFFFF',
    },
    b3: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    b4: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    cta1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
    cta2: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#FFFFFF',
    },
    textLink1: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.1em',
      color: '#FFFFFF',
    },
  },
};
export default typography;
